<template>
    <div class="grey darken-1 empty-layout">
        <router-view/>
    </div>
</template>


<script>
import messages from '@/plugins/listMessages.js'
export default {
    computed: {
        error(){
            return this.$store.getters.error
        }
    },
    watch: {
        error(fbErr){
            console.log(fbErr)
            this.$error(messages[fbErr.code] || "Что-то пошло не так")
        }
    }
}
</script>